var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-verificador" }, [
    _c("div", { staticClass: "vx-logo cursor-pointer text-center m-top" }, [
      _c("img", {
        staticStyle: { width: "190px" },
        attrs: { src: _vm.logoFull }
      })
    ]),
    _c(
      "div",
      { staticClass: "caja-pdf" },
      [
        _c("pdf", { attrs: { src: this.url } }),
        _c(
          "div",
          { staticClass: "descarga" },
          [
            _c("vs-icon", {
              attrs: { icon: "description", size: "small", color: "white" }
            }),
            _c("a", { attrs: { href: this.url, target: "_blank" } }, [
              _vm._v("Descargar Documento")
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }